
import React, { PropsWithChildren, ReactElement } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { useWidthContext } from '../../providers/Width';
import { Button, Row, Col } from '../../importCL';

interface IHeroBenefitsCtaProps extends MappedComponentProperties {
    desktopImgPath?: string;
    mobileImgPath?: string;
    altText?: string;
    mobileAltText?: string;
    title?: string;
    subTitle?: string;
    disclaimer?: string;
    ctaLabel?: string;
    ctaLink?: string;
    newTab?: boolean;
    marginBottom?: string;

}

export const HeroBenefitsCtaEditConfig = {
    emptyLabel: 'Hero Benefits CTA',
    isEmpty: (props: PropsWithChildren<IHeroBenefitsCtaProps>) => {
        return !props || !props.desktopImgPath;
    },
};

const HeroBenefitsCta = (props: PropsWithChildren<IHeroBenefitsCtaProps>): JSX.Element => {
    const { width } = useWidthContext();
    const imageAltText = width <= 768 && props.mobileAltText ? props.mobileAltText : props.altText;
    const backgroundImage = width <= 768 && props.mobileImgPath ? props.mobileImgPath : props.desktopImgPath;
    const queryParams = new URLSearchParams(window.location.search);
    const partnerId = queryParams.get('PartnerId');
    const ctaLink = props.ctaLink && partnerId ? props.ctaLink.replace('{{UUID}}', partnerId) : props.ctaLink;

    return (
        <section id='hero-benefits-cta'
            className='HeroBenefitsCta flex flex-col items-center'
            style={{ marginBottom: width > 768 ? `${props.marginBottom}px` : 'auto' }}
        >
            <div role='img'
                className='w-full h-[27.5rem] md:h-[6.25rem] bg-cover bg-center'
                aria-label={imageAltText}
                style={{ backgroundImage: `${backgroundImage ? ` url(${backgroundImage})` : ''}` }}
            >
            </div>
            <Row as='article' className='bg-white top-0 mt-[-16.875rem] w-3/4 max-w-[70.5rem] md:mt-0 md:w-full md:max-w-full'>
                <Col className='flex flex-col !px-6 items-center text-center md:items-start md:text-left md:!px-3'>
                    {props.title &&
                        <h1 className='font-light text-[2rem] leading-[2.75rem] pb-0 pt-10 px-[5.1875rem] md:pb-2 md:pt-6 md:px-0'>{transformHTMLParserLinks(props.title)}</h1>
                    }
                    {props.subTitle &&
                        <h2 className='pt-0 font-bold pb-8 text-[1.125rem] leading-[1.5625rem] px-[5.1875rem] md:px-0'>{transformHTMLParserLinks(props.subTitle)}</h2>
                    }
                    {props.ctaLabel &&
                        <div className='flex justify-center pb-6 w-full'>
                            <Button
                                className='!py-3 !px-6'
                                size='medium'
                                variant='solid'
                                href={ctaLink}
                                tabIndex={0}
                                target={props.newTab ? '_blank' : '_self'}
                            >
                                {transformHTMLParserLinks(props.ctaLabel) as unknown as ReactElement}
                            </Button>
                        </div>
                    }
                    {props.disclaimer &&

                        <div className='pb-6 leading-6 text-sm w-[70%] max-w-[46.5rem] md:w-full md:max-w-full'
                        >{transformHTMLParserLinks(props.disclaimer)}
                        </div>
                    }
                    <hr />
                </Col>
            </Row>
        </section>
    );
};

export default HeroBenefitsCta;
